import { Box, FormControl, FormHelperText, FormLabel, Input, InputGroup, InputRightElement } from '@chakra-ui/react';
import { Field } from 'formik';
import { useTranslation } from 'react-i18next';
import { NumericFormat } from 'react-number-format';

const CurrencyFormField = ({ name, label, placeholder, required, rightElement, disabled = false, decimalScale = 2, allowNegative = false, mb = 4 }) => {
	const { t } = useTranslation();

	return (
		<Field name={name}>
			{({ field, meta, form }) => (
				<Box mb={mb}>
					<FormControl id={name}>
						<FormLabel>
							{t(label)}
							{required && <span style={{ color: 'red' }}>*</span>}
						</FormLabel>
						<InputGroup size="md">
							<NumericFormat
								{...field}
								customInput={Input}
								fontSize="lg"
								name="name"
								value={field?.value}
								placeholder={t(placeholder)}
								thousandSeparator={true}
								decimalScale={decimalScale}
								allowNegative={allowNegative}
								onValueChange={(values) => form?.setFieldValue(name, values?.floatValue)}
								disabled={disabled}
								width="100%"
								height="49px"
								style={{ borderWidth: '1px', borderColor: '#E2E8F0' }}
							/>
							{rightElement && <InputRightElement width="6rem">{rightElement}</InputRightElement>}
						</InputGroup>
						{meta.touched && meta.error && (
							<FormHelperText id={`error-message-${name}`} color="red.400" fontSize="12px">
								{t(name)} {t('is')} {t(meta.error)}
							</FormHelperText>
						)}
					</FormControl>
				</Box>
			)}
		</Field>
	);
};

export default CurrencyFormField;
